import React from "react";
import { type TradeInAemCheckboxType, TradeInAemContactFormId } from "../../../utils/constants";
import { type TradeInAemDispatchType, useTradeInAemSelector } from "../../../redux/store";
import * as Styles from "../../../../common-deprecated/styles/v2/toyota/components/Form";
import PlaceholderUrl from "../../../../common-deprecated/components/PlaceholderUrl";
import { IconExclamation } from "../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { TradeInAemLabel, useTradeInAemLabel } from "../../../utils/labels";
import { setTradeInAemCheckboxValue } from "../../../redux/actions/TradeInAemContactFormActions";
import { IconWrapper } from "../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { useDispatch } from "../../../../shared-logic/redux/store";

const formItemId = TradeInAemContactFormId.PrivacyDisclaimers;

// This implementation is *very* similar to UscForm (see UscFormPrivacyRadioButtons for more explanation), so updates here might be relevant in there as well.
// It was not worth it to centralize these React components as the selectors/dispatchers/labels are already different.
// Styles are already shared as well (styled components).
const ContactFormPrivacyRadioButton = ({ showRequiredErrors }: { showRequiredErrors: boolean }): JSX.Element | null => {
    const formItem: TradeInAemCheckboxType | undefined = useTradeInAemSelector(
        (state) => state.tradeInAemContact[formItemId],
    );

    if (!formItem) return null;

    return (
        <>
            {formItem.items.map((item) => (
                <RadioButtonSet item={item} showRequiredErrors={showRequiredErrors} key={item.label} />
            ))}
        </>
    );
};

type RadioButtonSetProps = { item: TradeInAemCheckboxType["items"][number]; showRequiredErrors: boolean };
const RadioButtonSet = ({ item, showRequiredErrors }: RadioButtonSetProps): JSX.Element => {
    const { label, value, selected, url, required, interacted } = item;

    const dispatch = useDispatch<TradeInAemDispatchType>();
    const [acceptLabel, denyLabel] = useTradeInAemLabel([
        "tradeInAemContactDisclaimerAccept",
        "tradeInAemContactDisclaimerReject",
    ]);

    return (
        <>
            <Styles.Description>
                {url ? <PlaceholderUrl url={url} placeholderString={label} tag="link" /> : label}
                {required && <Styles.MandatoryField largeFontSize>*</Styles.MandatoryField>}
            </Styles.Description>
            <Styles.RadioGroup>
                <Styles.Radio key={`${value}-true`} hasError={showRequiredErrors && !interacted}>
                    <input
                        type="radio"
                        id={`${formItemId}-${value}-true`}
                        name={`${formItemId}-${value}`}
                        value="true"
                        checked={interacted ? selected : false}
                        onChange={() => {
                            dispatch(setTradeInAemCheckboxValue(formItemId, value, true));
                        }}
                    />
                    <label htmlFor={`${formItemId}-${value}-true`}>{acceptLabel}</label>
                </Styles.Radio>
                <Styles.Radio key={`${value}-false`} hasError={showRequiredErrors && !interacted}>
                    <input
                        type="radio"
                        id={`${formItemId}-${value}-false`}
                        name={`${formItemId}-${value}`}
                        value="false"
                        checked={interacted ? !selected : false}
                        onChange={() => {
                            dispatch(setTradeInAemCheckboxValue(formItemId, value, false));
                        }}
                    />
                    <label htmlFor={`${formItemId}-${value}-false`}>{denyLabel}</label>
                </Styles.Radio>
            </Styles.RadioGroup>
            {showRequiredErrors && !interacted && (
                <Styles.ErrorField>
                    <TradeInAemLabel label="tradeInAemFieldRequired" />
                    <IconWrapper iconColor="primaryBlack">
                        <IconExclamation />
                    </IconWrapper>
                </Styles.ErrorField>
            )}
        </>
    );
};
export default ContactFormPrivacyRadioButton;
